import styled from "styled-components";

export const SummaryCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 16px;
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const BottomInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
